import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { PageContainer } from '../../../common/components/PageContainer';
import { useAuthContext } from '../../../common/hooks/use-auth-context.hook';
import { useDevicesApi } from '../../../common/hooks/use-devices-api.hook';
import { DeviceSessionsView } from '../../../modules/seats/components/DeviceSessionsView';

/** Home > Devices: the account's seats and every device signed in to it. */
export const DevicesPage = () => {
  const { t } = useTranslation();
  const api = useDevicesApi();
  const { logout } = useAuthContext();
  const navigate = useNavigate();

  return (
    <PageContainer breadcrumbs={[{ label: t('SIDEBAR.ACCOUNT.TITLE', 'Account') }, { label: t('SEATS.PAGE.TITLE') }]}>
      <div className="flex flex-col gap-6">
        <div>
          <h1 className="font-heading text-2xl font-medium tracking-tight">{t('SEATS.PAGE.TITLE')}</h1>
          <p className="mt-1 max-w-2xl text-sm text-muted-foreground">{t('SEATS.PAGE.SUBTITLE')}</p>
        </div>
        <DeviceSessionsView
          load={api.getOverview}
          revoke={api.revoke}
          rename={api.rename}
          revokeOthers={api.revokeOthers}
          // The API already ended this session: just leave.
          onSignedOutHere={() => {
            logout({ remote: false });
            navigate('/login', { replace: true });
          }}
        />
      </div>
    </PageContainer>
  );
};

export default DevicesPage;
